import { RootState } from "../../reducers";
import { NewsFeedPost } from "./types";

const EMPTY_ARRAY: NewsFeedPost[] = [];

export const postsSelector = (state: RootState): NewsFeedPost[] =>
  state.news.posts?.data || EMPTY_ARRAY;

export const hasMorePostsSelector = (state: RootState): boolean =>
  state.news.posts?.hasMore || false;

export const arePostsLoadingSelector = (state: RootState): boolean =>
  state.news.arePostsLoading;

export const arePostsMarkingAsReadSelector = (state: RootState): boolean =>
  state.news.arePostsMarkingAsRead;
